import { option, readonlyArray, string } from 'fp-ts';
import { flow } from 'fp-ts/function';

/**
 * Remove metadata from base64 string (cut everything before 'base64,')
 */
export const getBase64Body = flow(
    string.split(','),
    readonlyArray.last,
    option.getOrElse(() => string.empty)
);

const getBase64 = async (file: File | Blob) =>
    new Promise<string>((resolve, reject) => {
        if (!file) {
            reject(new TypeError('File not found'));
        }

        const reader = new window.FileReader();
        reader.readAsDataURL(file);

        // We can safely cast to string since readAsDataURL() always returns string
        reader.onload = () => resolve(getBase64Body(reader.result as string));

        reader.onerror = () => {
            if (file instanceof File) {
                reject(new Error(`Failed to read file: ${file.name} ${reader.error?.toString()}`));
            } else {
                reject(new Error(`Failed to read blob: ${reader.error?.toString()}`));
            }
        };
    });

export default getBase64;
